module.exports = __webpack_public_path__ + "static/img/12.0b051fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/sp/12.png
// module id = T7eY
// module chunks = 0